import { actionGenerator } from '../../utils/redux/actionGenerator';
import {
  ERecommendationActionTypes,
  IRecommendationFulfilledPayload,
  IRecommendationMoreFulfilledPayload,
  IRecommendationToggleFavoritePayload,
} from './types';

export const fetchRecommendationsPending = actionGenerator<ERecommendationActionTypes.Pending>(
  ERecommendationActionTypes.Pending,
);

export const fetchRecommendationsFulfilled = actionGenerator<
  ERecommendationActionTypes.Fulfilled,
  IRecommendationFulfilledPayload
>(ERecommendationActionTypes.Fulfilled);

export const fetchRecommendationsRejected = actionGenerator<ERecommendationActionTypes.Rejected>(
  ERecommendationActionTypes.Rejected,
);

export const fetchMoreRecommendationsPending = actionGenerator<ERecommendationActionTypes.MorePending>(
  ERecommendationActionTypes.MorePending,
);

export const fetchMoreRecommendationsFulfilled = actionGenerator<
  ERecommendationActionTypes.MoreFulfilled,
  IRecommendationMoreFulfilledPayload
>(ERecommendationActionTypes.MoreFulfilled);

export const fetchMoreRecommendationsRejected = actionGenerator<ERecommendationActionTypes.MoreRejected>(
  ERecommendationActionTypes.MoreRejected,
);

export const fetchRecommendationsToggleFavorite = actionGenerator<
  ERecommendationActionTypes.ToggleFavorite,
  IRecommendationToggleFavoritePayload
>(ERecommendationActionTypes.ToggleFavorite);
